import { TrafficParamNameListResponse } from "../responses/trafficParamNameListResponse"
import { TrafficParamValuesResponse } from "../responses/trafficParamValuesResponse"
import { TrafficSummaryListResponse } from "../responses/trafficSummaryListResponse"
import { TrafficParamValuesRequest } from "../requests/trafficParamValuesRequest"
import { TrafficSummaryRequest } from "../requests/trafficSummaryRequest"
import { AxiosInstance } from "axios"

export class TrafficApi {
  private sicalcClient: AxiosInstance

  constructor(sicalcClient: AxiosInstance) {
    this.sicalcClient = sicalcClient
  }

  /**
   * The parameters the traffic can be grouped by, with their display names
   */
  public async getParamNames() {
    const url = `/api/v1/traffic/param-names/`
    const response = await this.sicalcClient.get<TrafficParamNameListResponse>(url)
    return response.data
  }

  /**
   * All values that occur in a scenario for the requested parameters, used to
   * build the filters on a custom scenario
   */
  public async getParamValues(request: TrafficParamValuesRequest) {
    const url = `/api/v1/traffic/param-values/`
    const response = await this.sicalcClient.post<TrafficParamValuesResponse>(url, request)
    return response.data
  }

  /**
   * Traffic for the given scenarios, grouped by the requested parameters
   */
  public async getSummary(request: TrafficSummaryRequest) {
    const url = `/api/v1/traffic/summary/`
    const response = await this.sicalcClient.post<TrafficSummaryListResponse>(url, request)
    return response.data
  }
}
